import { BottomCTA } from "@hamlak/ui";
import appIconUrl from "@hamlak/ui/brand/app-icon.png";
import catSymbolUrl from "@hamlak/ui/brand/cat-symbol.svg";
import "./status.css";

type StatusPageProps = {
  icon: "cat" | "app";
  title: string;
  /** \n 은 줄바꿈 */
  description: string;
  cta: string;
  onCta: () => void;
  testId?: string;
};

/** F09 풀페이지 공용(네트워크 끊김·강제 업데이트·서비스 점검): 심볼 + 제목 + 본문 + 하단 CTA. */
export function StatusPage({ icon, title, description, cta, onCta, testId }: StatusPageProps) {
  return (
    <main className="page page--bare status" data-testid={testId}>
      <div className="status__body">
        {icon === "app" ? (
          <img src={appIconUrl} alt="" className="status__icon status__icon--app" />
        ) : (
          <img src={catSymbolUrl} alt="" className="status__icon" />
        )}
        <h1 className="status__title">{title}</h1>
        <p className="status__desc">{description}</p>
      </div>
      <BottomCTA primary={{ variant: "brandSolid", children: cta, onClick: onCta }} />
    </main>
  );
}
